import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useLocation, useParams } from "react-router-dom";
import { backendURL, useApiFetch } from "../../utils/api";
import { ShootingSession } from "../../types/ShootingSession";
import { SessionReport } from "../../components/SessionReport";
import { getShootingEventConfig } from "../../configs/utils/ShootingEventConfigFactory";
import { ShootingEventConfig } from "../../types/ShootingEventConfig";

interface SessionReportsLocationState {
    targetOwnerName?: string;
    competitionName?: string;
    competitionDate?: string;
}

function SessionReports() {
    const apiFetch = useApiFetch();
    const { sessionId } = useParams<{ sessionId: string }>();
    const location = useLocation();
    const [session, setSession] = useState<ShootingSession | null>(null);
    const [shootingEventConfig, setShootingEventConfig] = useState<ShootingEventConfig | null>(null);
    const locationState = location.state as SessionReportsLocationState | null;
    const targetOwnerName = session?.owner || locationState?.targetOwnerName;
    const competitionName = locationState?.competitionName;
    const competitionDate = locationState?.competitionDate;

    useEffect(() => {
        if (!sessionId) {
            return;
        }

        const loadSession = async () => {
            try {
                const response = await apiFetch(`${backendURL}/shooting-sessions/${sessionId}`, {
                    method: "GET",
                    includeAuth: true
                });

                console.log("Loaded session: ", response);
                setSession(response);
                setShootingEventConfig(getShootingEventConfig(response.shootingEventId));
            } catch (err) {
                console.error("Failed to load session: ", err);
            }
        };

        loadSession();
    }, [sessionId]);

    return (
        <Container>
            <Row>
                <Col>
                    {session && shootingEventConfig ? (
                        <div>
                            <SessionReport targetResults={session.targetResults} dateString={session.sessionDate} shotsPerTarget={session.shotsPerTarget} hitRadius={session.hitRadius} targetOwnerName={targetOwnerName} competitionName={competitionName} competitionDate={competitionDate} shootingEventConfig={shootingEventConfig} />
                        </div>
                    ) : (
                        <p className="text-center mb-4">Brak danych</p>
                    )}
                </Col>
            </Row>
        </Container>
    )
}

export default SessionReports;
